export function PageLoader() {
  return (
    <div
      className="flex min-h-[50vh] items-center justify-center"
      style={{ background: 'var(--sp-bg)' }}
      role="status"
      aria-live="polite"
      aria-label="Carregando página"
    >
      <div
        className="h-10 w-10 animate-spin rounded-full border-[3px] border-t-transparent"
        style={{ borderColor: 'var(--sp-border)', borderTopColor: 'var(--sp-blue)' }}
      />
    </div>
  )
}
